import * as i0 from '@angular/core';
import { Directive, Optional, Self, Input, InjectionToken, Inject, EventEmitter, Output, ContentChildren, NgModule } from '@angular/core';
import * as i2 from '@angular/router';
import * as i1 from '@angular/material/tabs';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import * as i1$1 from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { map, tap, takeUntil, filter } from 'rxjs/operators';

class FsRouterLinkDirective {
    constructor(_elementRef, _matTab, _routerLink) {
        this._elementRef = _elementRef;
        this._matTab = _matTab;
        this._routerLink = _routerLink;
        this._updateReplaceUrl();
    }
    _updateReplaceUrl() {
        if (this._matTab && this._routerLink && this.replaceUrl === void 0) {
            this._routerLink.replaceUrl = true;
        }
    }
}
FsRouterLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRouterLinkDirective, deps: [{ token: i0.ElementRef }, { token: i1.MatTabLink, optional: true, self: true }, { token: i2.RouterLinkWithHref, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
FsRouterLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsRouterLinkDirective, selector: "[routerLink]", inputs: { replaceUrl: "replaceUrl" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsRouterLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[routerLink]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.MatTabLink, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i2.RouterLinkWithHref, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }]; }, propDecorators: { replaceUrl: [{
                type: Input
            }] } });

const FS_TABS_CONFIG = new InjectionToken('fs-tabs.config');

class FsTabsHeaderBaseDirective {
    constructor(_tabsConfig, _renderer, _breakpointObserver, _ngZone, _el) {
        this._tabsConfig = _tabsConfig;
        this._renderer = _renderer;
        this._breakpointObserver = _breakpointObserver;
        this._ngZone = _ngZone;
        this._el = _el;
        this._destroy$ = new Subject();
    }
    ngOnInit() {
        if (this.mobileSticky === undefined) {
            this.mobileSticky = this._tabsConfig.mobileSticky;
        }
    }
    get element() {
        return this._el.nativeElement;
    }
    ngAfterViewInit() {
        if (this.getMatTabHeaderEl()) {
            this._ngZone.runOutsideAngular(() => {
                this._listenWidthChanges();
            });
        }
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    _listenWidthChanges() {
        this._breakpointObserver.observe([
            `(min-width: ${this._tabsConfig.mobileBreakpoint}px)`,
        ])
            .pipe(map((state) => !state.matches), tap((isMobile) => this._updateStickyPosition(isMobile)), takeUntil(this._destroy$))
            .subscribe();
    }
    _updateStickyPosition(mobileMode) {
        if (this.mobileSticky) {
            if (mobileMode) {
                this._renderer.addClass(this.getMatTabHeaderEl(), 'fs-tabs-sticky');
            }
            else {
                this._renderer.removeClass(this.getMatTabHeaderEl(), 'fs-tabs-sticky');
            }
        }
    }
}
FsTabsHeaderBaseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderBaseDirective, deps: [{ token: FS_TABS_CONFIG }, { token: i0.Renderer2 }, { token: i1$1.BreakpointObserver }, { token: i0.NgZone }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FsTabsHeaderBaseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsTabsHeaderBaseDirective, inputs: { mobileSticky: "mobileSticky" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderBaseDirective, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_TABS_CONFIG]
                }] }, { type: i0.Renderer2 }, { type: i1$1.BreakpointObserver }, { type: i0.NgZone }, { type: i0.ElementRef }]; }, propDecorators: { mobileSticky: [{
                type: Input
            }] } });

class FsTabsHeaderNavDirective extends FsTabsHeaderBaseDirective {
    constructor(_tabsConfig, _renderer, _breakpointObserver, _ngZone, _el) {
        super(_tabsConfig, _renderer, _breakpointObserver, _ngZone, _el);
        this.orientation = 'horizontal';
    }
    getMatTabHeaderEl() {
        return this.element;
    }
}
FsTabsHeaderNavDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderNavDirective, deps: [{ token: FS_TABS_CONFIG }, { token: i0.Renderer2 }, { token: i1$1.BreakpointObserver }, { token: i0.NgZone }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FsTabsHeaderNavDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsTabsHeaderNavDirective, selector: "mat-tab-nav-bar, [mat-tab-nav-bar], [matTabNavBar]", inputs: { orientation: "orientation" }, host: { properties: { "class.fs-tabs-vertical": "orientation === \"vertical\"" } }, exportAs: ["fsTabsHeaderNav"], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderNavDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-tab-nav-bar, [mat-tab-nav-bar], [matTabNavBar]',
                    exportAs: 'fsTabsHeaderNav',
                    host: {
                        '[class.fs-tabs-vertical]': 'orientation === "vertical"',
                    },
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_TABS_CONFIG]
                }] }, { type: i0.Renderer2 }, { type: i1$1.BreakpointObserver }, { type: i0.NgZone }, { type: i0.ElementRef }]; }, propDecorators: { orientation: [{
                type: Input
            }] } });

class FsTabsTabDirective {
}
FsTabsTabDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsTabDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FsTabsTabDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsTabsTabDirective, selector: "mat-tab,matTab", inputs: { name: "name", data: "data" }, exportAs: ["fsTabsTab"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsTabDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-tab,matTab',
                    exportAs: 'fsTabsTab',
                }]
        }], propDecorators: { name: [{
                type: Input
            }], data: [{
                type: Input
            }] } });

class FsTabsHeaderTabGroupDirective extends FsTabsHeaderBaseDirective {
    constructor(_renderer, _breakpointObserver, _ngZone, _el, _cdRef, _tabsConfig, _tabGroup) {
        super(_tabsConfig, _renderer, _breakpointObserver, _ngZone, _el);
        this._cdRef = _cdRef;
        this._tabGroup = _tabGroup;
        this.orientation = 'horizontal';
        this.selectedChange = new EventEmitter();
        this.selectedDataChange = new EventEmitter();
    }
    getMatTabHeaderEl() {
        var _a, _b;
        return (_b = ((_a = this._tabGroup) === null || _a === void 0 ? void 0 : _a._tabHeader)._elementRef) === null || _b === void 0 ? void 0 : _b.nativeElement;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        if (this.selected) {
            setTimeout(() => {
                this.selectTab(this.selected);
            }, 300); // TODO fix me
        }
        this._tabGroup.selectedIndexChange
            .pipe(map((index) => {
            return this._getFsTab(index);
        }), filter((tab) => (!!tab && (this.selected === undefined || tab.name !== this.selected))), takeUntil(this._destroy$))
            .subscribe((tab) => {
            this.selected = tab.name;
            this.selectedChange.emit(tab.name);
        });
        this._tabGroup.selectedIndexChange
            .pipe(map((index) => {
            return this._getFsTab(index);
        }), takeUntil(this._destroy$))
            .subscribe((tab) => {
            this.selectedDataChange.emit(tab.data);
        });
    }
    ngOnChanges(changes) {
        if (changes.selected && !changes.selected.firstChange && changes.selected.currentValue !== undefined) {
            this.selectTab(changes.selected.currentValue);
        }
    }
    selectTab(name) {
        const index = this._fsTabs
            .toArray().findIndex((fsTab) => {
            return name === fsTab.name;
        });
        if (index !== -1) {
            this._tabGroup.selectedIndex = index;
            this._tabGroup.focusTab(index);
            this._cdRef.markForCheck();
        }
    }
    _getFsTab(index) {
        const fsTabs = this._fsTabs.toArray();
        return fsTabs[index];
    }
}
FsTabsHeaderTabGroupDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderTabGroupDirective, deps: [{ token: i0.Renderer2 }, { token: i1$1.BreakpointObserver }, { token: i0.NgZone }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: FS_TABS_CONFIG }, { token: i1.MatTabGroup, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
FsTabsHeaderTabGroupDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsTabsHeaderTabGroupDirective, selector: "mat-tab-group, matTabGroup, [matTabGroup]", inputs: { orientation: "orientation", selected: "selected", selectedData: "selectedData" }, outputs: { selectedChange: "selectedChange", selectedDataChange: "selectedDataChange" }, host: { properties: { "class.fs-tabs-vertical": "orientation === \"vertical\"", "class.fs-tabs-horizontal": "orientation === \"horizontal\"" } }, providers: [
        {
            provide: MAT_TABS_CONFIG,
            useValue: { animationDuration: '0ms' },
        },
    ], queries: [{ propertyName: "_fsTabs", predicate: FsTabsTabDirective, descendants: true }], exportAs: ["fsTabsHeaderTabGroup"], usesInheritance: true, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsHeaderTabGroupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'mat-tab-group, matTabGroup, [matTabGroup]',
                    exportAs: 'fsTabsHeaderTabGroup',
                    host: {
                        '[class.fs-tabs-vertical]': 'orientation === "vertical"',
                        '[class.fs-tabs-horizontal]': 'orientation === "horizontal"',
                    },
                    providers: [
                        {
                            provide: MAT_TABS_CONFIG,
                            useValue: { animationDuration: '0ms' },
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$1.BreakpointObserver }, { type: i0.NgZone }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [FS_TABS_CONFIG]
                }] }, { type: i1.MatTabGroup, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { orientation: [{
                type: Input
            }], selected: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], selectedData: [{
                type: Input
            }], selectedDataChange: [{
                type: Output
            }], _fsTabs: [{
                type: ContentChildren,
                args: [FsTabsTabDirective, { descendants: true }]
            }] } });

class FsTabsModule {
    static forRoot(config) {
        config = Object.assign({
            mobileBreakpoint: 600,
            mobileSticky: true,
        }, config);
        return {
            ngModule: FsTabsModule,
            providers: [
                { provide: FS_TABS_CONFIG, useValue: config },
            ]
        };
    }
}
FsTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsModule, declarations: [FsRouterLinkDirective,
        FsTabsHeaderTabGroupDirective,
        FsTabsHeaderNavDirective,
        FsTabsTabDirective], exports: [FsRouterLinkDirective,
        FsTabsHeaderTabGroupDirective,
        FsTabsHeaderNavDirective,
        FsTabsTabDirective] });
FsTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    declarations: [
                        FsRouterLinkDirective,
                        FsTabsHeaderTabGroupDirective,
                        FsTabsHeaderNavDirective,
                        FsTabsTabDirective,
                    ],
                    exports: [
                        FsRouterLinkDirective,
                        FsTabsHeaderTabGroupDirective,
                        FsTabsHeaderNavDirective,
                        FsTabsTabDirective,
                    ],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FS_TABS_CONFIG, FsRouterLinkDirective, FsTabsHeaderNavDirective, FsTabsHeaderTabGroupDirective, FsTabsModule, FsTabsTabDirective };
